import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Clock, Layers, FlaskConical, ClipboardCheck, Beaker, PlusCircle } from 'lucide-react';
const reasons = [{
  icon: <Clock data-id="element-228" />,
  title: 'Recuperá tus domingos',
  desc: 'Todo ya está armado. No arrancás desde cero. Solo abrís, imprimís y usás.'
}, {
  icon: <Layers data-id="element-229" />,
  title: 'Secuencia clara por año',
  desc: 'Cada contenido ya está ordenado según el nivel para que no improvises ni mezcles temas.'
}, {
  icon: <FlaskConical data-id="element-230" />,
  title: 'Química más visual y aplicable',
  desc: 'Con actividades, ejemplos, esquemas y experiencias que ayudan a que el alumno entienda de verdad.'
}, {
  icon: <ClipboardCheck data-id="element-231" />,
  title: 'Menos corrección, más claridad',
  desc: 'Las rúbricas y criterios integrados te ahorran horas y te ordenan la evaluación.'
}, {
  icon: <Beaker data-id="element-232" />,
  title: 'Laboratorio sin caos',
  desc: 'Tenés guías, registros y propuestas listas para aplicar sin correr a último momento.'
}, {
  icon: <PlusCircle data-id="element-233" />,
  title: 'Actualizaciones y material extra',
  desc: 'En las ofertas superiores accedés a recursos complementarios para seguir mejorando tu planificación.'
}];
export function WhyChoose() {
  return <section className="py-6 md:py-12 px-4 bg-blue-50/50" data-id="element-234">
      <div className="max-w-6xl mx-auto" data-id="element-235">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-center text-slate-900 mb-6 md:mb-10" data-id="element-236">
          ¿Por qué elegir el Mega Pack?
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-237">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-3xl border border-blue-100 shadow-xl shadow-blue-900/5 flex flex-col items-center text-center group hover:border-blue-300 transition-colors" data-id="element-238">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-blue-50 rounded-2xl flex items-center justify-center mb-6 text-blue-600 group-hover:scale-110 transition-transform" data-id="element-239">
                {cloneElement(reason.icon as React.ReactElement, {
              size: 28
            })}
              </div>
              <h3 className="text-lg md:text-xl font-black text-slate-900 mb-3 leading-tight" data-id="element-240">
                {reason.title}
              </h3>
              <p className="text-slate-600 text-sm md:text-base font-medium leading-relaxed" data-id="element-241">
                {reason.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}